import isPlurallApp from "./isPlurallApp";

export default function getAppName() {
  return isPlurallApp() ? "Adapta" : "Seneca";
}
